<template>
  <div class="project-user-list page-box">
    <div class="page-content">
      <div class="content-header">
        <div class="m-input-outer">
          <el-input
            class="search-input box-item"
            v-model="name"
            placeholder="角色名称"
            style="width: 100%"
            clearable
          ></el-input>
        </div>
        <el-input
          class="search-input box-item hidden-xs-only"
          v-model="name"
          placeholder="角色名称"
          clearable
        ></el-input>
        <vs-button
          type="info"
          class="search-btn btn box-item"
          @click="searchHandle"
        >查询</vs-button>
        <vs-button
          v-if="isAuth('sys:role:save')"
          class="add-btn btn box-item"
          @click="addHandle"
        >新增</vs-button>
        <vs-button
          v-if="isAuth('sys:role:delete')"
          :disabled="selected.length < 1"
          class="mutil-btn "
          @click="deleteHandle()"
        >批量删除</vs-button>
      </div>
      <div class="vs-table-outer">
        <vs-table
          multiple
          v-model="selected"
          :data="listData"
        >
          <template
            slot="thead">
            <vs-th>
              ID
            </vs-th>
            <vs-th>
              备注
            </vs-th>
            <vs-th>
              角色名称
            </vs-th>
            <vs-th>
              操作
            </vs-th>
          </template>
          <template slot-scope="{data}">
            <vs-tr
              v-for="(tr, index) in data"
              :key="index"
              :data="tr"
            >
              <vs-td>
                {{tr.roleId}}
              </vs-td>
              <vs-td>
                {{tr.remark || '-'}}
              </vs-td>
              <vs-td>
                {{tr.roleName}}
              </vs-td>
              <vs-td>
                <el-button
                  type="text"
                  v-if="isAuth('sys:role:update')"
                  iconClass="edit-21"
                  class=""
                  @click.stop="editHandle(tr)"
                >修改</el-button>
                <el-button
                  type="text"
                  v-if="isAuth('sys:role:delete')"
                  iconClass="trash1"
                  class="delete-btn"
                  @click="deleteHandle(tr)"
                >删除</el-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
      <div class="pagination-outer" v-if="total">
        <div class="paginnation-left">
          <size-change @sizeChange="sizeChange"></size-change>
          <span class="tatol-count">合计 {{total}} 条</span>
        </div>
        <vs-pagination
          class="pagination-box"
          :max="max"
          :total="pageSize"
          v-model="page"
        ></vs-pagination>
      </div>
    </div>
    <add-role-dialog
      :dialog-show="addDialogShow"
      @close="closeAddDialog"
      @add-success="addUserSuccess"
    ></add-role-dialog>
    <edit-role-dialog
      :role-id="currentRoleId"
      :dialog-show="editDialogShow"
      @close="closeEditDialog"
      @add-success="editUserSuccess"
    ></edit-role-dialog>
    <multiple-delete-dialog
      ref="muldelete"
      :ids="ids"
      @sure-delete="confirmDelete"
    ></multiple-delete-dialog>
  </div>
</template>

<script>
import multipleDeleteDialog from "@/components/public/multipleDeleteDialog";
import editRoleDialog from '@/components/sys/roleList/editRoleDialog'
import addRoleDialog from "@/components/sys/roleList/addRoleDialog";
import { mapGetters } from 'vuex'
import { colorRgba,parseTime } from '@/utils/index'
import initData from "@/mixins/initData";
import {deleteRole} from "@/api/sys/roleList";
export default {
  name: "index",
  components: {
    addRoleDialog,
    editRoleDialog,
    multipleDeleteDialog,
  },
  data() {
    return {
      name: '',
      selected: [],
      typeList: [],
      red: '#D85E5F',
      green: '#41B883',
      addDialogShow: false,
      editDialogShow: false,
      currentRoleId: 0,
      ids: []
    }
  },
  mixins: [initData],
  computed: {
    ...mapGetters(['themeColor','userInfo']),
  },
  created(){
    this.init();
  },
  methods: {
    parseTime,
    beforeInit(){
      this.url = '/wx/sys/role/list';
      this.params = {
        page: this.page,
        limit: this.size,
        sidx: 'role_id',
        order: 'desc',
      }

      if(this.name){
        this.params.roleName = this.name;
      }
      return true;
    },
    addHandle(){
      this.addDialogShow = true;
    },
    addUserSuccess(){
      this.addDialogShow = false;
      this.searchHandle();
    },
    editHandle(row){
      this.currentRoleId = row.roleId;
      setTimeout(() => {
        this.editDialogShow = true;
      },200);
    },
    editUserSuccess(){
      this.editDialogShow = false;
      this.searchHandle();
    },
    closeEditDialog(){
      this.currentRoleId = 0;
      this.editDialogShow = false;
    },
    deleteHandle(row){
      this.ids = row ? [row.roleId] : this.selected.map(item => item.roleId);
      this.$refs.muldelete.dialogShow = true;
    },
    confirmDelete(ids){
      deleteRole(ids).then((res) => {
        this.$message({
          type: 'success',
          message: '已删除'
        });
        this.$refs.muldelete.dialogShow = false;
        this.searchHandle();
      })
    },
    closeAddDialog(){
      this.addDialogShow = false;
    },
    getStatus(tr){
      if(tr.status === 0){
        return '禁用';
      }else {
        return '正常';
      }
    },
    getStyle(tr){
      if(tr.status === 0){
        return {
          backgroundColor: colorRgba(this.red ,0.1),
          color: this.red,
        };
      }else {

        return {
          backgroundColor: colorRgba(this.green,0.1),
          color: this.green,
        };
      }
    },
    searchHandle(){
      this.page = 1;
      this.init();
    },
  },
}
</script>

<style lang="scss" scoped>
.project-user-list {
  .box-item {
    margin-bottom: 10px;
  }
  .btn {
    margin-right: 10px;
  }
  .vs-table-outer {
    .vs-con-table {
      min-width: 1200px;
    }
  }
  .tag-box {
    padding: 5px 10px;
    border-radius: 15px;
  }
  .reject-reason {
    max-width: 120px;
  }
}
</style>
